import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { icons } from './sidebar';
import MoreMenu from './moreMenu';
import { isUserAllowed, isFieldUser } from '../utils/roleHelpers';
import { MISC_LABELS } from '../constants/labels';

const BarIcon = ({ children }) => (
    <svg className="bn-ic" viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">{children}</svg>
);

const moreIcon = <><circle cx="5" cy="12" r="1.6" /><circle cx="12" cy="12" r="1.6" /><circle cx="19" cy="12" r="1.6" /></>;

const Tab = ({ to, icon, label, onClick }) => (
    <NavLink to={to} className="bn-tab" onClick={onClick}>
        <BarIcon>{icon}</BarIcon>
        <span className="bn-label">{label}</span>
    </NavLink>
);

/**
 * App-style bottom navigation, mobile only (hidden ≥768px via CSS).
 * Surfaces the 4 primary destinations the user has access to, plus a
 * "More" button that opens a full menu of every reachable page.
 */
const BottomNav = () => {

    const { t } = useTranslation();
    const [moreOpen, setMoreOpen] = useState(false);

    // Primary destinations in priority order; show the first 4 the user can access.
    const candidates = [
        { to: '/home',      icon: icons.overview, label: t('nav.overview'), allow: isUserAllowed('/home') },
        { to: '/jobs',      icon: icons.jobs,     label: t('nav.jobs'),     allow: isUserAllowed('/jobs') },
        { to: '/clients',   icon: icons.clients,  label: t('nav.clients'),  allow: isUserAllowed('/clients') },
        { to: '/calendar',  icon: icons.calendar, label: t('nav.calendar'), allow: isUserAllowed('/calendar') },
        { to: '/route-plan',icon: icons.route,    label: isFieldUser() ? MISC_LABELS.myRoute : t('nav.route'), allow: isUserAllowed('/route-plan') },
        { to: '/cash-flow', icon: icons.cashflow, label: t('nav.cashFlow'),allow: isUserAllowed('/cash-flow') },
        { to: '/expenses',  icon: icons.expenses, label: t('nav.expenses'), allow: isUserAllowed('/expenses') },
    ];

    const tabs = candidates.filter(c => c.allow).slice(0, 4);

    return (
        <>
            <nav className="bottom-nav d-md-none" role="navigation" aria-label={t('nav.primaryNavigation')}>
                {tabs.map(t => <Tab key={t.to} to={t.to} icon={t.icon} label={t.label} onClick={() => setMoreOpen(false)} />)}
                <button
                    type="button"
                    className={`bn-tab bn-more ${moreOpen ? 'active' : ''}`}
                    aria-expanded={moreOpen}
                    onClick={() => setMoreOpen(o => !o)}
                >
                    <BarIcon>{moreIcon}</BarIcon>
                    <span className="bn-label">{t('common.more')}</span>
                </button>
            </nav>

            <MoreMenu open={moreOpen} onClose={() => setMoreOpen(false)} />
        </>
    );
};

export default BottomNav;
